var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingWarning = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    transform: "rotate(90 35 1)",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.6111C16.5 16.2554 16.658 15.9142 16.9393 15.6627C17.2206 15.4112 17.6022 15.2698 18 15.2698C18.3978 15.2698 18.7794 15.4112 19.0607 15.6627C19.342 15.9142 19.5 16.2554 19.5 16.6111V24.6587C19.5 25.0145 19.342 25.3556 19.0607 25.6072C18.7794 25.8587 18.3978 26 18 26C17.6022 26 17.2206 25.8587 16.9393 25.6072C16.658 25.3556 16.5 25.0145 16.5 24.6587V16.6111ZM18 10C17.6022 10 17.2206 10.1413 16.9393 10.3928C16.658 10.6444 16.5 10.9855 16.5 11.3413C16.5 11.697 16.658 12.0382 16.9393 12.2897C17.2206 12.5412 17.6022 12.6825 18 12.6825C18.3978 12.6825 18.7794 12.5412 19.0607 12.2897C19.342 12.0382 19.5 11.697 19.5 11.3413C19.5 10.9855 19.342 10.6444 19.0607 10.3928C18.7794 10.1413 18.3978 10 18 10Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading_warning.7167cc67892cb49fe823e5097f999a94.svg";